import { gql, useQuery } from '@apollo/client';
import { useHistory, useParams } from 'react-router-dom';
export const baseLink = '';

export default function RedirectHelper() {
  const result = useRedirectHelper();
  if (result.success) return null;
  return (
    <div>
      <h1>{result.message}</h1>
    </div>
  );
}

/**
 *
 * @returns {{success: true}|{success: false, message: React.ReactNode}}
 */
export function useRedirectHelper() {
  const history = useHistory();
  const { workspaceId: urlWorkspaceId } = useParams();
  const { workspaceId, loading } = useData();
  if (loading)
    // Return true because there aren't any issues yet.
    return {
      success: true,
    };
  // Handle when users somehow get access to the wrong domain.
  // Inform the user instead of doing magic redirects.
  if (window.location.origin.includes('bbimports.netlify.app'))
    return {
      success: false,
      message: (
        <span>
          This is not a valid domain. Please use{' '}
          <a href="https://imports.bottlebooks.me">imports.bottlebooks.me</a>{' '}
          instead.
        </span>
      ),
    };
  if (!workspaceId) {
    window.location.replace(
      `${
        import.meta.env.VITE_PORTFOLIO_HOSTNAME
      }/login/username?redirect_url=${encodeURIComponent(window.location.href)}`
    );
    // We know how to handle this, so return success: true;
    return { success: true };
  }
  if (!urlWorkspaceId && workspaceId) {
    history.push(`/${workspaceId}/inProgress`);
    // We know how to handle this, so return success: true;
    return { success: true };
  }

  // We shouldn't get this far, so show a generic error message.
  return { success: false, message: <span>Something isn't right...</span> };
}

function useData() {
  const { data, loading } = useQuery(query);

  return {
    loading,
    workspaceId: data?.mySession?.currentWorkspaceId,
    data,
  };
}

const query = gql`
  query UserSession {
    version
    status
    mySession {
      userId
      workspaceIds
      currentWorkspaceId
    }
  }
`;
